import {lazyWithRetry} from '../lazyWithRetry/lazyWithRetry';

export const LazySalesforce = lazyWithRetry(() => import('./salesforce'));
